import React from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { Styles } from '../../@types';
import { mergeSx } from '../../utils';

interface Props extends TypographyProps {
  text: string;
}

export const PrimaryTitle: React.FC<Props> = ({ text, sx, ...other }) => {
  return (
    <Typography variant="body1" sx={mergeSx(style.title, sx)} {...other}>
      {text}
    </Typography>
  );
};

const style: Styles = {
  title: {
    fontSize: 25,
    fontWeight: 800,
  },
};
